import service from '@/middleware'

/**
 * Llamadas al API email
 */
const mapApi = {

    async getCurrentState (enterpriseId) {
        const result = await service.http.post(`/api/map/currentState`, { enterpriseId })
        return result
    }
}

export default mapApi
